import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/shared/services/shared.service';
import { Router } from '@angular/router';
import { LOCAL_STORAGE } from 'src/app/shared';

@Component({
  selector: 'app-user-confirmation',
  templateUrl: './user-confirmation.component.html',
  styleUrls: ['./user-confirmation.component.scss'],
})
export class UserConfirmationComponent implements OnInit {
  message: any;
  userData: any = null;
  creditInvoice: string;
  compName = 'UserRegistrationBannerComponent';

  isNonBuyingPhysician: boolean = this.sharedService.getLocalStorage(
    LOCAL_STORAGE.REGISTRATION.NON_BUYING_PHYSICIAN_REGISTRATION
  );

  constructor(
    private readonly cdr: ChangeDetectorRef,
    protected sharedService: SharedService,
    protected router: Router
  ) {}

  ngOnInit(): void {
    window.scroll(0, 0);
    this.creditInvoice = 'invoiceTable';
    this.userData = JSON.parse(localStorage.getItem('userConfirmationData'));
    this.message = this.userData?.msgData;
    this.cdr.detectChanges();
  }

  userConfirmationRedirect(): void {
    const redirectUrls = {
      nonBuyingPhysician: '/influenza/dashboard',
      standard: '/my-account/account-overview',
    };
    if (this.isNonBuyingPhysician) {
      this.router.navigate([redirectUrls.nonBuyingPhysician]);
    } else {
      this.router.navigate([redirectUrls.standard]);
    }
  }
}
